import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isLogin } from "../utils/utils";

export default function AuthProtectedRoutes({ children }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  return (
    <>
      {!isLogin() && (
        <>
          {/* {children?.props?.props?.label === "Home" ?<Navigate to="/login" /> : children} */}
          {children}
        </>
      )}
      {isLogin() && (
        <Navigate
          to={`/dashboard?${
            searchParams != null &&
            searchParams.get("email_verify") != null &&
            "email_verify=" + searchParams.get("email_verify")
          }`}
        />
      )}
    </>
  );
}
